module.exports = __webpack_public_path__ + "img/level-perks-btn.cc9a23bd.png";